/// <reference types="./proposals.d.mts" />
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $position from "../../../../ds/ds/internals/position.mjs";
import * as $shadows from "../../../../ds/ds/shadows.mjs";
import * as $display from "../../../../ds/ds/typography/display.mjs";
import * as $text from "../../../../ds/ds/typography/text.mjs";
import * as $ds_utils from "../../../../ds/ds/utils.mjs";
import * as $window from "../../../../ds/web/browser/window.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $a from "../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $angle from "../../../../sketch/sketch/css/angle.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { percent, percent_, px, px_, rem } from "../../../../sketch/sketch/css/length.mjs";
import * as $transform from "../../../../sketch/sketch/css/transform.mjs";
import * as $element from "../../../../sketch_lustre/sketch/lustre/element.mjs";
import * as $h from "../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $keyed from "../../../../sketch_lustre/sketch/lustre/element/keyed.mjs";
import { toList, prepend as listPrepend, divideFloat, divideInt } from "../../../gleam.mjs";
import * as $utils from "../../../utils.mjs";

export function questionnaire_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.flex("1"),
      $css.gap(px(12)),
      $css.overflow("hidden"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function header(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(8)),
      $css.padding_bottom(px(12)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function drag_and_drop_zone(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.padding(px(64)),
      $css.border_radius(px(8)),
      $css.border("1px dashed " + $colors.light.grey_400),
      $css.flex_direction("column"),
      $css.align_items("center"),
      $css.margin_("0 auto"),
      $css.color($colors.light.text_display),
      $css.gap(px(32)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function icon_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.width(px(48)),
      $css.height(px(48)),
      $css.padding(px(12)),
      $css.background($colors.light.foam_100),
      $css.border_radius(px(24)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function drop_title(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose($display.xs())]));
  return $h.div(_pipe, attrs, children);
}

function layout_wrapper_() {
  return $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(16)),
      $css.margin_("0 auto"),
      $css.width(percent(100)),
      $css.max_width(px(400)),
    ]),
  );
}

export function details_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.compose(layout_wrapper_()), $css.margin_top(px(36))]),
  );
  return $h.form(_pipe, attrs, children);
}

export function submit_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.justify_content("end"),
      $css.gap(px(8)),
      $css.padding(px(10)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_radius(px(8)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function layout_wrapper(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(layout_wrapper_())]));
  return $h.div(_pipe, attrs, children);
}

export function drop_subtitle(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.text_align("center"), $css.compose($text.md($text.regular))]),
  );
  return $h.div(_pipe, attrs, children);
}

export function details_title(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose($display.xs())]));
  return $h.div(_pipe, attrs, children);
}

export function round_icon(icon) {
  let _pipe = $css.class$(
    toList([
      $css.border_radius(px(128)),
      $css.padding(px(8)),
      $css.background($colors.light.foam_200),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}

export function details_subtitle(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose($text.md($text.regular))]));
  return $h.div(_pipe, attrs, children);
}

export function details_owner_label(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.text_display),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function details_owner_picture(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.regular)),
      $css.color($colors.light.text_body),
      $css.display("flex"),
      $css.gap(px(8)),
      $css.align_items("center"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function file_input(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($button.classes.secondary()),
      $css.letter_spacing("0.5px"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function main_file_input(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose($button.classes.primary())]));
  return $h.div(_pipe, attrs, children);
}

export function explanatory_text(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose($text.lg($text.medium))]));
  return $h.div(_pipe, attrs, children);
}

export function spreadsheet_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.overflow_y("hidden"),
      $css.align_items("start"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function spreadsheet(size, attrs, children) {
  let internal_size = size - 1;
  let _pipe = $css.class$(
    toList([
      $css.display("grid"),
      $css.grid_template_columns(
        ("min-content repeat(" + $int.to_string(internal_size)) + ", minmax(auto,max-content))",
      ),
      $css.border_right("1px solid " + $colors.light.grey_200),
      $ds_utils.overflow("auto"),
      $css.flex("1"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function spreadsheet_sheets(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.gap(px(4)),
      $css.border_top("1px solid " + $colors.light.grey_200),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

function spreadsheet_sheet_cl() {
  return $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.border_bottom_left_radius(px(8)),
      $css.border_bottom_right_radius(px(8)),
      $css.border("0.5px solid " + $colors.light.grey_200),
      $css.border_top("none"),
      $css.padding_("4px 24px"),
      $css.cursor("pointer"),
      $css.hover(
        toList([
          $css.background($colors.light.grey_100),
          $css.color($colors.light.grey_800),
        ]),
      ),
    ]),
  );
}

export function spreadsheet_sheet(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(spreadsheet_sheet_cl()),
      $css.background($colors.light.text_white),
      $css.color($colors.light.grey_600),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function active_spreadsheet_sheet(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(spreadsheet_sheet_cl()),
      $css.background($colors.light.grey_50),
      $css.color($colors.light.text_display),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

function cell_base() {
  return $css.class$(
    toList([
      $css.compose($text.xs($text.regular)),
      $css.border("0.5px solid " + $colors.light.grey_200),
      $css.padding(px(8)),
    ]),
  );
}

export function empty_cell(attrs) {
  let _pipe = $css.class$(toList([$css.compose(cell_base())]));
  return $h.div(_pipe, attrs, toList([]));
}

export function filled_cell(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(cell_base())]));
  return $h.div(_pipe, attrs, children);
}

function shared_header_style() {
  return $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.padding_("8px 12px"),
      $css.background($colors.light.grey_50),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.text_align("center"),
      $css.color($colors.light.text_display),
    ]),
  );
}

export function spreadsheet_header(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(shared_header_style()),
      $css.position("sticky"),
      $css.border("0.5px solid " + $colors.light.grey_200),
      $css.border_top("1px solid " + $colors.light.grey_200),
      $css.border_bottom("1px solid " + $colors.light.grey_200),
      $css.top(px(0)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(9)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function spreadsheet_header_line(index, max, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(shared_header_style()),
      $css.border("0.5px solid " + $colors.light.grey_200),
      $css.border_left("1px solid " + $colors.light.grey_200),
      $css.position("sticky"),
      $css.left(px(0)),
      $css.display("flex"),
      $css.gap(px(9)),
      $css.align_items("center"),
      $css.z_index(max - index),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function dropdown_wrapper(opacity, attrs, children) {
  let _pipe = $css.class$(toList([$css.opacity(opacity)]));
  return $h.div(_pipe, attrs, children);
}

export function show_title(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($display.xs()),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(6)),
      $css.flex("1"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function empty_sheet(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.color($colors.light.grey_600),
      $css.compose($text.xl($text.regular)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_card(z_index, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.z_index(z_index),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.transition("width .3s"),
      $css.padding(px(24)),
      $css.gap(px(12)),
      $css.position("relative"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function checkbox(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_column("1"), $css.grid_row("1")]));
  return $h.div(_pipe, attrs, children);
}

export function question_number(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.grid_column("2"),
      $css.grid_row("1"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(4)),
      $css.flex_direction("row"),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_list(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.display("flex"), $css.flex_direction("column")]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_questions(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.flex("1"),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_radius_("8px 8px 0px 0px"),
      $ds_utils.overflow("auto"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function questions_container(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.position("relative"),
      $css.border_radius_("8px 8px 8px 0px"),
      $css.selector(
        ":has(+ .pagination)",
        toList([$css.border_radius_("8px 8px 0px 0px")]),
      ),
      $css.border("1px solid " + $colors.light.grey_200),
      $ds_utils.overflow("auto"),
      $css.scrollbar_gutter("stable"),
      $css.flex("1"),
      $css.selector("::-webkit-scrollbar", toList([$css.width(px(13))])),
      $css.selector(
        "::-webkit-scrollbar:horizontal",
        toList([$css.height(px(13))]),
      ),
      $css.selector(
        "::-webkit-scrollbar-thumb",
        toList([
          $css.box_shadow("inset 0 0 8px 8px " + $colors.light.grey_400),
          $css.border("solid 2px transparent"),
          $css.border_radius(px(14)),
          $css.transition("box-shadow .3s"),
        ]),
      ),
      $css.selector(
        "::-webkit-scrollbar-thumb:vertical",
        toList([$css.border_left_width(px(3))]),
      ),
      $css.selector(
        "::-webkit-scrollbar-thumb:horizontal",
        toList([$css.border_top_width(px(3))]),
      ),
      $css.selector(
        "::-webkit-scrollbar-track:vertical",
        toList([$css.border_left("solid 1px " + $colors.light.grey_200)]),
      ),
      $css.selector(
        "::-webkit-scrollbar-track:horizontal",
        toList([$css.border_top("solid 1px " + $colors.light.grey_200)]),
      ),
    ]),
  );
  return $keyed.div(
    _pipe,
    listPrepend($a.id("questions-container"), attrs),
    children,
  );
}

export function comments_container(heights, attrs, children) {
  let height = heights[0];
  let max_height = heights[1];
  let _pipe = $css.class$(
    toList([
      $ds_utils.overflow("auto"),
      $css.max_height(px(max_height)),
      $css.scrollbar_width("none"),
    ]),
  );
  return $h.div(
    _pipe,
    listPrepend($a.id("comments-container"), attrs),
    toList([
      $h.div(
        $css.class$(toList([$css.height(px(height))])),
        toList([]),
        children,
      ),
    ]),
  );
}

export function questions_comments_container(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.overflow("hidden"),
      $css.gap_("0 12px"),
      $css.flex("1"),
      $css.display("flex"),
      $css.flex_direction("row"),
    ]),
  );
  return $h.div(
    _pipe,
    listPrepend($a.id("questions-comments-container"), attrs),
    children,
  );
}

export function question_card_header(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("grid"),
      $css.align_items("center"),
      $css.gap(px(12)),
      $css.grid_template_columns("auto auto 1fr auto"),
      $css.grid_column("1"),
      $css.z_index(1),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_spreadsheet_sheets(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.display("flex"), $css.gap(px(4)), $ds_utils.overflow_x("auto")]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_status(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.gap(px(8)),
      $css.grid_row("1"),
      $css.grid_column("3"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_question(content) {
  let content$1 = $utils.escape_html(content);
  let _pipe = $css.class$(
    toList([
      $css.grid_column("1 / 4"),
      $css.grid_row("2"),
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.text_display),
    ]),
  );
  let _pipe$1 = $element.class_name(_pipe);
  let _pipe$2 = $a.class$(_pipe$1);
  let _pipe$3 = $list.wrap(_pipe$2);
  return ((_capture) => {
    return $el.unsafe_raw_html("", "div", _capture, content$1);
  })(_pipe$3);
}

export function question_question_skeleton(children) {
  let _pipe = $css.class$(
    toList([
      $css.grid_column("1 / 4"),
      $css.grid_row("2"),
      $css.compose($text.md($text.medium)),
      $css.color($colors.light.text_display),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function question_owner(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.grid_column("5"),
      $css.grid_row("1"),
      $css.display("flex"),
      $css.gap(px(8)),
      $css.position("relative"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_actions(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.grid_column("2"),
      $css.grid_row("2"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.position("relative"),
      $css.gap(px(16)),
      $css.align_self("center"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function proposal_actions(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.grid_column("1"),
      $css.grid_row("1"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.position("relative"),
      $css.gap(px(16)),
      $css.align_self("center"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_improvements(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_column("1"), $css.grid_row("3")]));
  return $h.div(_pipe, attrs, children);
}

export function question_attachments(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.regular)),
      $css.grid_column("1"),
      $css.grid_row("4"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("space-between"),
      $css.gap(px(8)),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function attachment_close_base() {
  return $css.class$(
    toList([
      $css.opacity(0.0),
      $css.transition("opacity .3s"),
      $css.color($colors.light.grey_600),
      $css.compose($text.sm($text.medium)),
    ]),
  );
}

export function attachment_pill(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.background($colors.light.grey_100),
      $css.padding(px(8)),
      $css.border_radius(px(8)),
      $css.max_width(px(200)),
      $css.overflow("hidden"),
      $css.white_space("nowrap"),
      $css.selector("> div", toList([$css.flex_shrink(0.0)])),
      $css.hover(
        toList([
          $css.child(attachment_close_base(), toList([$css.opacity(1.0)])),
        ]),
      ),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function attachment_close(attrs, children) {
  let _pipe = attachment_close_base();
  return $h.button(_pipe, attrs, children);
}

export function attachment_text(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.overflow("hidden"),
      $css.text_overflow("ellipsis"),
      $css.flex("1"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function improvement_button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($button.classes.secondary()),
      $css.background($colors.light.ai_100),
      $css.color($colors.light.ai_800),
      $css.gap(px(4)),
      $css.compose($text.xs($text.medium)),
      $css.padding_("4px 12px"),
      $css.box_shadow($shadows.xs()),
      $css.border("1px solid transparent"),
      $css.hover(toList([$css.background($colors.light.ai_800)])),
      $css.disabled(toList([$css.opacity(0.7), $css.pointer_events("none")])),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function colored_text(color, text) {
  return $h.span(
    $css.class$(toList([$css.color(color), $css.transition("color .3s")])),
    toList([]),
    toList([$h.text(text)]),
  );
}

export function validate_button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($button.classes.secondary()),
      $css.background($colors.light.success_50),
      $css.color($colors.light.success_800),
      $css.border("none"),
      $css.gap(px(4)),
      $css.compose($text.xs($text.medium)),
      $css.padding_("4px 12px"),
      $css.box_shadow($shadows.xs()),
      $css.hover(
        toList([
          $css.background($colors.light.success_800),
          $css.color($colors.light.text_white),
        ]),
      ),
      $css.disabled(
        toList([
          $css.opacity(0.7),
          $css.hover(
            toList([
              $css.background($colors.light.text_white),
              $css.color($colors.light.grey_800),
              $css.border("1px solid " + $colors.light.grey_200),
              $css.cursor("not-allowed"),
            ]),
          ),
        ]),
      ),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function cancel_button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($button.classes.secondary()),
      $css.background($colors.light.grey_100),
      $css.color($colors.light.grey_800),
      $css.border("none"),
      $css.gap(px(4)),
      $css.compose($text.xs($text.medium)),
      $css.padding_("4px 12px"),
      $css.box_shadow($shadows.xs()),
      $css.hover(
        toList([
          $css.background($colors.light.grey_800),
          $css.color($colors.light.text_white),
        ]),
      ),
      $css.disabled(toList([$css.opacity(0.7)])),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function improvements_conversations(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.grid_column("1"),
      $css.grid_row("6"),
      $css.padding(px(12)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(12)),
      $css.border("1px solid " + $colors.light.grey_400),
      $css.border_radius(px(8)),
      $css.max_height(px(700)),
      $css.overflow("hidden"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function improvement_assistant_bubble(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.justify_content("start"),
      $css.white_space("pre-line"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function user_bubble(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.background($colors.light.grey_100),
      $css.padding_("8px 16px"),
      $css.border_radius(px(8)),
      $css.max_width(px(700)),
      $css.compose($text.sm($text.regular)),
      $css.color($colors.light.text_display),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function assistant_bubble(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.padding_("8px 16px"),
      $css.border_radius(px(8)),
      $css.max_width(px(700)),
      $css.compose($text.sm($text.regular)),
      $css.color($colors.light.text_display),
    ]),
  );
  let _pipe$1 = $element.class_name(_pipe);
  let _pipe$2 = $a.class$(_pipe$1);
  let _pipe$3 = ((_capture) => { return $list.prepend(attrs, _capture); })(
    _pipe$2,
  );
  return ((_capture) => {
    return $el.unsafe_raw_html("", "div", _capture, children);
  })(_pipe$3);
}

export function improvement_user_bubble(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.display("flex"), $css.justify_content("end")]),
  );
  return $h.div(_pipe, attrs, children);
}

export function error_response_bubble(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.white_space("pre-line"), $css.color($colors.light.grey_800)]),
  );
  return $h.div(_pipe, attrs, children);
}

export function improvements_conversation_messages(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column-reverse"),
      $css.gap(px(12)),
      $css.flex("1"),
      $ds_utils.overflow("auto"),
      $css.margin_("-12px -12px 0 -12px"),
      $css.padding_("12px 12px 0 12px"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function improvements_input(attrs) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.regular)),
      $css.flex("1"),
      $css.placeholder(toList([$css.color($colors.light.grey_800)])),
      $css.background("transparent"),
      $css.appearance("none"),
      $css.border("none"),
      $css.outline("none"),
    ]),
  );
  return $h.input(_pipe, attrs);
}

export function improvements_input_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.background($colors.light.grey_50),
      $css.border_radius(px(8)),
      $css.color($colors.light.grey_800),
      $css.padding(px(8)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_sources(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("space-between"),
      $css.gap(px(8)),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function question_sources_infos(attrs, children) {
  return $h.div_(attrs, children);
}

export function confidence_score(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.text_transform("uppercase"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(12)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function confidence_score_highlight(value, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.color(
        (() => {
          if (value >= 0.8) {
            return $colors.light.success_800;
          } else {
            if (value >= 0.35) {
              return $colors.light.warning_800;
            } else {
              return $colors.light.error_800;
            }
          }
        })(),
      ),
      $css.padding_("4px 8px"),
      $css.background(
        (() => {
          if (value >= 0.8) {
            return $colors.light.success_50;
          } else {
            if (value >= 0.35) {
              return $colors.light.warning_50;
            } else {
              return $colors.light.error_50;
            }
          }
        })(),
      ),
      $css.border_radius(px(8)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function separator() {
  return $h.hr(
    $css.class$(
      toList([
        $css.width_("calc(100% - 48px)"),
        $css.height(px(1)),
        $css.margin_("12px 24px"),
        $css.background($colors.light.grey_200),
      ]),
    ),
    toList([]),
  );
}

export function confidence_score_tooltip(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.regular)),
      $css.margin_top(px(12)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.padding(px(12)),
      $css.gap(px(12)),
      $css.border_radius(px(8)),
      $css.background($colors.light.grey_50),
      $css.box_shadow($shadows.m()),
      $css.color($colors.light.grey_800),
      $css.max_height(px(350)),
      $ds_utils.overflow("auto"),
      $css.white_space("pre-wrap"),
      $css.position("absolute"),
      $css.bottom(percent(100)),
      $css.margin_bottom(px(8)),
      $css.right(px(0)),
      $css.min_width(px(200)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function details_collaborators_class() {
  return $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.display("flex"),
      $css.gap(px(8)),
      (() => {
        let _pipe = $css.padding_("8px 10px");
        return $css.important(_pipe);
      })(),
      $css.color($colors.light.grey_800),
      $css.background($colors.light.text_white),
      $css.border_radius(px(8)),
      $css.position("relative"),
      $css.align_items("center"),
      $css.hover(toList([$css.background($colors.light.grey_200)])),
      $css.disabled(
        toList([
          $css.background("transparent"),
          $css.cursor("default"),
          $css.padding(px(0)),
        ]),
      ),
    ]),
  );
}

export function small_button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(details_collaborators_class()),
      $css.border("1px solid " + $colors.light.grey_400),
      $css.position("relative"),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function comment_mention_selector_class() {
  return $css.class$(
    toList([
      $css.compose($text.md($text.regular)),
      $css.white_space("nowrap"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.padding_("10px 14px"),
      $css.gap(px(8)),
      $css.padding(px(0)),
      $css.padding_right(px(30)),
      $css.border("none"),
      $css.color($colors.light.text_body),
      $css.hover(toList([$css.background($colors.light.grey_100)])),
    ]),
  );
}

export function details_collaborators_button(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(details_collaborators_class())]));
  return $h.button(_pipe, attrs, children);
}

export function details_collaborators_loading_button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.display("flex"),
      $css.gap(px(8)),
      $css.padding(px(8)),
      $css.background($colors.light.grey_100),
      $css.color($colors.light.text_body),
      $css.border_radius(px(8)),
      $css.position("relative"),
      $css.align_items("center"),
      $css.pointer_events("none"),
      $css.hover(toList([$css.background($colors.light.grey_200)])),
      $css.disabled(toList([$css.cursor("default"), $css.padding(px(0))])),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function details_collaborators_icon(child) {
  let _pipe = $css.class$(toList([$css.width(px(20)), $css.height(px(20))]));
  return $h.div(_pipe, toList([]), toList([child]));
}

export function add_attachment_input(attrs) {
  let _pipe = $css.class$(toList([$css.display("none")]));
  return $h.input(_pipe, attrs);
}

export function question_body(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(12)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_radius(px(8)),
      $css.padding(px(12)),
      $css.focus_within(
        toList([
          $css.border("1px solid " + $colors.light.ai_400),
          $css.box_shadow("0px 0px 0px 4px " + $colors.light.ai_100),
        ]),
      ),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function radio_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.gap(px(8)),
      $css.align_items("center"),
      $css.compose($text.sm($text.regular)),
      $css.cursor("pointer"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function radio_content(selected, disabled) {
  let _pipe = $css.class$(
    toList([
      $css.width(px(6)),
      $css.height(px(6)),
      $css.border_radius(px(10)),
      $css.position("absolute"),
      $css.top(px(3)),
      $css.left(px(3)),
      $css.transition("background .3s"),
      $css.background(
        (() => {
          if (selected) {
            if (disabled) {
              return $colors.light.grey_400;
            } else {
              return $colors.light.text_display;
            }
          } else if (disabled) {
            return $colors.light.transparent;
          } else {
            return $colors.light.transparent;
          }
        })(),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

export function radio_button(selected, disabled) {
  let _pipe = $css.class$(
    toList([
      $css.width(px(14)),
      $css.height(px(14)),
      $css.border_radius(px(10)),
      $css.background($colors.light.text_white),
      $css.transition("border-color .3s"),
      $css.position("relative"),
      $css.border_width(px(1)),
      $css.border_style("solid"),
      $css.border_color(
        (() => {
          if (disabled) {
            return $colors.light.grey_200;
          } else if (selected) {
            return $colors.light.text_display;
          } else {
            return $colors.light.grey_400;
          }
        })(),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([radio_content(selected, disabled)]));
}

export function button_notification(children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.display("flex"),
      $css.justify_content("center"),
      $css.align_items("center"),
      $css.border_radius(percent(100)),
      $css.position("absolute"),
      $css.right(px(-8)),
      $css.top(px(-8)),
      $css.background($colors.light.text_display),
      $css.color($colors.light.text_white),
      $css.width(px(18)),
      $css.height(px(18)),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function button_icon(dark, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.position("relative"),
      $css.border_radius(px(20)),
      $css.width(px(30)),
      $css.height(px(30)),
      $css.background(
        (() => {
          if (dark) {
            return $colors.light.text_display;
          } else {
            return $colors.light.text_white;
          }
        })(),
      ),
      $css.color(
        (() => {
          if (dark) {
            return $colors.light.text_white;
          } else {
            return $colors.light.grey_800;
          }
        })(),
      ),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.transition("color .2s, background .2s"),
      $css.hover(
        toList([
          $css.background($colors.light.text_display),
          $css.color($colors.light.text_white),
        ]),
      ),
      $css.disabled(
        toList([
          $css.background($colors.light.text_white),
          $css.color($colors.light.grey_200),
          $css.cursor("default"),
          $css.pointer_events("none"),
        ]),
      ),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function details_collaborators_icon_delete(attrs, child) {
  let _pipe = $css.class$(
    toList([$css.width(px(16)), $css.height(px(16)), $css.cursor("pointer")]),
  );
  return $h.button(_pipe, attrs, toList([child]));
}

export function change_popup() {
  return $css.class$(
    toList([
      $css.position("absolute"),
      $css.bottom(px(50)),
      $css.border("1px solid " + $colors.light.grey_400),
      $css.border_radius(px(8)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.background($colors.light.text_white),
      $css.cursor("default"),
      $ds_utils.overflow("auto"),
      $css.max_height(px(500)),
      $css.box_shadow($shadows.m()),
    ]),
  );
}

export function add_collaborators_popup_left(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.compose(change_popup()), $css.width(px(250)), $css.left(px(0))]),
  );
  return $h.div(_pipe, attrs, children);
}

export function add_collaborators_popup_right(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(change_popup()),
      $css.width(px(250)),
      $css.right(px(0)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function add_collaborators_popup_title(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.color($colors.light.grey_800),
      $css.padding(px(10)),
      $css.position("sticky"),
      $css.top(px(0)),
      $css.background($colors.light.text_white),
      $css.border_bottom("1px solid " + $colors.light.grey_400),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function add_collaborator_button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("space-between"),
      $css.gap(px(8)),
      $css.padding(px(10)),
      $css.cursor("pointer"),
      $css.hover(toList([$css.background($colors.light.grey_100)])),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function collaborators_list(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.property("flex-wrap", "wrap"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function details_owner_picture_deletion(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.padding_("6px 10px"),
      $css.background($colors.light.text_white),
      $css.border_radius(px(8)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.white_space("nowrap"),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

function base_actions_popup() {
  return $css.class$(
    toList([
      $css.compose($text.md($text.medium)),
      $css.position("absolute"),
      $css.display("flex"),
      $css.z_index(9_000_000),
      $css.flex_direction("column"),
      $css.right(px(0)),
      $css.background($colors.light.text_white),
      $css.border_radius(px(8)),
      $css.box_shadow($shadows.m()),
      $css.border("1px solid " + $colors.light.grey_100),
      $css.overflow("hidden"),
    ]),
  );
}

export function actions_popup(rect, attrs, children) {
  let height = $window.inner_height($window.self());
  let _pipe = $css.class$(
    toList([
      $css.compose(base_actions_popup()),
      (() => {
        if (rect instanceof Some) {
          let rect$1 = rect[0];
          let $ = (divideInt(height, 2)) > $float.round(rect$1.top);
          if ($) {
            return $css.top(px_(rect$1.top + rect$1.height));
          } else {
            return $css.bottom_(
              ("calc(100vh - " + $float.to_string(rect$1.top)) + "px)",
            );
          }
        } else {
          return $css.top(px(50));
        }
      })(),
      (() => {
        if (rect instanceof Some) {
          let rect$1 = rect[0];
          return $css.right_(
            ("calc(100vw - " + $float.to_string(rect$1.right)) + "px)",
          );
        } else {
          return $css.none();
        }
      })(),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function action_title(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.grey_600),
      $css.padding_("10px 14px"),
      $css.border_bottom("1px solid " + $colors.light.grey_200),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function action_option(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.md($text.regular)),
      $css.white_space("nowrap"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.padding_("10px 14px"),
      $css.gap(px(8)),
      $css.padding_right(px(30)),
      $css.color($colors.light.text_body),
      $css.hover(toList([$css.background($colors.light.grey_100)])),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function action_link(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.md($text.regular)),
      $css.white_space("nowrap"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.padding_("10px 14px"),
      $css.gap(px(8)),
      $css.padding_right(px(30)),
      $css.color($colors.light.text_body),
      $css.hover(toList([$css.background($colors.light.grey_100)])),
      $css.text_decoration("none"),
    ]),
  );
  return $h.a(_pipe, attrs, children);
}

export function ai_text_input(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.flex("1"),
      $css.overflow("hidden"),
      $css.padding_("8px 12px"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function comment_container(offset, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.justify_content("start"),
      $css.align_items("start"),
      $css.width(rem(24.0)),
      $css.z_index(1),
      $css.position("relative"),
      $css.top(px(offset)),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function editable_comment(children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.justify_content("start"),
      $css.align_items("center"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function max_size_name(children) {
  let _pipe = $css.class$(
    toList([
      $css.max_width(px(150)),
      $css.text_overflow("ellipsis"),
      $css.overflow_x("hidden"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function comment_card(is_resolved, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.padding(px(12)),
      $css.margin_("6px 0"),
      $css.border_radius(px(8)),
      $css.width(percent(100)),
      (() => {
        if (is_resolved) {
          return $css.background($colors.light.blue_100);
        } else {
          return $css.background($colors.light.grey_50);
        }
      })(),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

function end_border_line() {
  let _pipe = $css.class$(
    toList([
      $css.margin_left(px(24)),
      $css.display("flex"),
      $css.justify_content("center"),
      $css.align_items("center"),
      $css.border_left("1px solid " + $colors.light.grey_400),
      $css.border_bottom("1px solid " + $colors.light.grey_400),
      $css.border_bottom_left_radius(px(8)),
      $css.width(px(50)),
      $css.height(px(80)),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

export function end_line_tree(comment_card) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.width(percent(100)),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([end_border_line(), comment_card]));
}

function border_top() {
  let _pipe = $css.class$(
    toList([
      $css.border_top("1px solid " + $colors.light.grey_400),
      $css.width(px(40)),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

function border_line() {
  let _pipe = $css.class$(
    toList([
      $css.margin_left(px(24)),
      $css.margin_top(px(-6)),
      $css.margin_bottom(px(-24)),
      $css.display("flex"),
      $css.justify_content("center"),
      $css.align_items("center"),
      $css.border_left("1px solid " + $colors.light.grey_400),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([border_top()]));
}

export function left_line_tree(comment_card) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.width(percent(100)),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([border_line(), comment_card]));
}

export function comment_reacted(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.border_radius(percent(50)),
      $css.padding(px(4)),
      $css.cursor("pointer"),
      $css.min_width(px(40)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.background($colors.light.blue_100),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function comment_react(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.border_radius(percent(50)),
      $css.padding(px(4)),
      $css.cursor("pointer"),
      $css.min_width(px(40)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.background($colors.light.text_white),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function comment_reacts(children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.padding(px(6)),
      $css.gap(px(4)),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function comment_header(children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.justify_content("space-between"),
      $css.align_items("center"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function comment_head(children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.justify_content("space-between"),
      $css.padding(px(6)),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function clickable(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.justify_content("space-between"),
      $css.cursor("pointer"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function mentions_list_draft(mentions) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.align_items("center"),
      $css.justify_content("flex-start"),
      $css.gap(px(2)),
      $css.padding(px(2)),
    ]),
  );
  return $h.div(_pipe, toList([]), mentions);
}

export function mentions_list_submitted(mentions) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.align_items("center"),
      $css.justify_content("flex-end"),
      $css.gap(px(2)),
      $css.padding(px(2)),
    ]),
  );
  return $h.div(_pipe, toList([]), mentions);
}

export function comment_actions(children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.gap(px(6)),
      $css.position("relative"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function comment_action(attrs, children) {
  let _pipe = $css.class$(toList([$css.cursor("pointer")]));
  return $h.div(_pipe, attrs, children);
}

export function date_display(children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.justify_content("center"),
      $css.align_items("center"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function create_comment(children) {
  let _pipe = $css.class$(
    toList([
      $css.padding_top(px(12)),
      $css.padding_left(px(12)),
      $css.width(percent(100)),
      $css.background($colors.light.text_white),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function comment_owner(children) {
  let _pipe = $css.class$(toList([$css.padding(px(6))]));
  return $h.div(_pipe, toList([]), children);
}

export function comment_value(children) {
  let _pipe = $css.class$(
    toList([$css.padding(px(12)), $css.line_height("24px"), $css.flex("1")]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function edited_text(children) {
  let _pipe = $css.class$(
    toList([$css.line_height("14px"), $css.color($colors.light.grey_600)]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function comment_input(children) {
  let _pipe = $css.class$(
    toList([
      $css.padding_top(px(12)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(8)),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function placeholder_comment_card() {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.justify_content("center"),
      $css.align_items("center"),
      $css.width(rem(24.0)),
      $css.padding(px(12)),
      $css.border_radius(px(8)),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

export function comments_wrapper(children) {
  let _pipe = $css.class$(
    toList([
      $css.flex("24rem"),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.max_width(rem(24.0)),
      $css.padding(px(12)),
      $css.transition("max-width .3s, padding .3s, flex .3s"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function comments_wrapper_closed(children) {
  let _pipe = $css.class$(
    toList([
      $css.flex("0"),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.max_width(rem(0.0)),
      $css.padding(px(0)),
      $css.transition("max-width .3s, padding .3s, flex .3s"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function questions_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.flex("1"),
      $css.overflow("hidden"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

function typing_dot(size) {
  return $css.class$(
    toList([
      $css.background($colors.light.grey_800),
      $css.width(px(size)),
      $css.height(px(size)),
      $css.border_radius(px(20)),
      $css.animation("pulse 2s infinite"),
    ]),
  );
}

function typing_dot_1(size) {
  let _pipe = $css.class$(toList([$css.compose(typing_dot(size))]));
  return $h.div(_pipe, toList([]), toList([]));
}

function typing_dot_2(size) {
  let _pipe = $css.class$(
    toList([$css.compose(typing_dot(size)), $css.animation_delay("600ms")]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

function typing_dot_3(size) {
  let _pipe = $css.class$(
    toList([$css.compose(typing_dot(size)), $css.animation_delay("1200ms")]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

export function typing_indicator(size) {
  let _pipe = $css.class$(
    toList([$css.display("flex"), $css.gap(px(divideInt(size, 2)))]),
  );
  return $h.div(
    _pipe,
    toList([]),
    toList([typing_dot_1(size), typing_dot_2(size), typing_dot_3(size)]),
  );
}

export function loading_answer_indicator(children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.md($text.medium)),
      $css.position("absolute"),
      $css.top(px(0)),
      $css.right(px(0)),
      $css.left(px(0)),
      $css.bottom(px(0)),
      $css.background("#fffb"),
      $css.border_radius(px(8)),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.gap(px(16)),
      $css.property("backdrop-filter", "blur(6px)"),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

function base_icon() {
  return $css.class$(
    toList([
      $css.width(px(20)),
      $css.height(px(20)),
      $css.border_radius(px(24)),
      $css.color($colors.light.grey_800),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.transition("color .3s, background .3s"),
      $css.border("none"),
      $css.cursor("pointer"),
      $css.outline("none"),
      $css.hover(
        toList([
          $css.background($colors.light.grey_100),
          $css.color($colors.light.text_display),
        ]),
      ),
      $css.disabled(
        toList([
          $css.background($colors.light.grey_100),
          $css.color($colors.light.grey_400),
          $css.cursor("default"),
        ]),
      ),
    ]),
  );
}

export function trash_icon_button(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(base_icon())]));
  return $h.button(_pipe, attrs, children);
}

export function empty_trash_icon_button() {
  let _pipe = $css.class$(toList([$css.compose(base_icon())]));
  return $h.div(_pipe, toList([]), toList([]));
}

export function more_icon_button(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(base_icon())]));
  return $h.button(_pipe, attrs, children);
}

export function collapse_icon_button(opened, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(base_icon()),
      (() => {
        if (opened) {
          return $css.none();
        } else {
          return $css.transform(toList([$transform.rotate($angle.deg(180.0))]));
        }
      })(),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function filters_button(active, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.compose(
        (() => {
          if (active) {
            return $button.classes.primary();
          } else {
            return $button.classes.secondary();
          }
        })(),
      ),
      $css.padding_("8px 18px"),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

function success_bar(success) {
  let _pipe = $css.class$(
    toList([
      $css.width(percent_(success)),
      $css.height(px(10)),
      $css.background($colors.light.success_800),
      $css.transition("width .3s"),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

function failure_bar(failure) {
  let _pipe = $css.class$(
    toList([
      $css.width(percent_(failure)),
      $css.height(px(10)),
      $css.background($colors.light.error_800),
      $css.transition("width .3s"),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([]));
}

export function progress_bar(success, failure, total) {
  let success$1 = divideFloat((success * 100.0), total);
  let failure$1 = divideFloat((failure * 100.0), total);
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex("1"),
      $css.height(px(10)),
      $css.border_radius(px(10)),
      $css.overflow("hidden"),
      $css.align_items("center"),
      $css.justify_content("space-between"),
      $css.background($colors.light.grey_200),
    ]),
  );
  return $h.div(
    _pipe,
    toList([]),
    toList([success_bar(success$1), failure_bar(failure$1)]),
  );
}

export function success_text(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.success_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function error_text(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.error_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function padding_left(children) {
  let _pipe = $css.class$(toList([$css.padding_left(px(40))]));
  return $h.div(_pipe, toList([]), toList([children]));
}

export function file_pill(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.regular)),
      $css.background($colors.light.grey_100),
      $css.border_radius(px(8)),
      $css.display("flex"),
      $css.padding_("4px 8px"),
      $css.align_items("center"),
      $css.gap(px(8)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function close_button(attrs) {
  let _pipe = $css.class$(toList([$css.cursor("pointer")]));
  return $h.div(_pipe, attrs, toList([$icons.tiny($icons.cross())]));
}

export function no_questions_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.flex("1"),
      $css.min_height(rem(60.0)),
      $css.justify_content("center"),
      $css.align_items("center"),
      $css.border("1px solid " + $colors.light.grey_400),
      $css.border_radius_("8px 8px 8px 0px"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function add_context(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.gap(px(8)),
      $css.padding(px(6)),
      $css.border_radius(px(4)),
      $css.position("relative"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function toggle_add_context(reversed, icon) {
  let _pipe = $css.class$(
    toList([
      $css.width(px(20)),
      $css.height(px(20)),
      $css.transition("transform .3s"),
      $css.transform(
        (() => {
          if (reversed) {
            return toList([$transform.rotate($angle.deg(-90.0))]);
          } else {
            return toList([$transform.rotate($angle.deg(0.0))]);
          }
        })(),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}

export function context_label(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.text_display),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function context_input(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.regular)),
      $css.color($colors.light.text_display),
      $css.gap(px(4)),
      $css.display("flex"),
      $css.flex_direction("column"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function collapse_title_icon_button(opened, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(base_icon()),
      $css.transform(
        (() => {
          if (opened) {
            return toList([$transform.rotate($angle.deg(0.0))]);
          } else {
            return toList([$transform.rotate($angle.deg(180.0))]);
          }
        })(),
      ),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function proposal_metadata_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.gap(px(8)),
      $css.max_width(percent(50)),
      $css.min_height(px(42)),
      $ds_utils.overflow("scroll"),
      $css.overflow_y("hidden"),
      $css.scrollbar_width("none"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}
